import { getChartExpense, handleKeyDown } from '_services';
import { createItems, editItems, getGstTypeData, getManufacturerList, getMeasurementUnitList, getPartCategoryList } from '_services/workShopServices/workShopServices';
import { CityDropdownForTrip, CommonInput, CrossButton, CustomSelect } from 'components';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { errorSchema, utils } from 'helper';
import AddEditManufacturerModel from 'modals/AddEditManufacturerModel';
import AddPartsCategory from 'modals/AddPartsCategory';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import StorageService from 'utils/StorageServices';


const WorkshopAddItem = (props) => {
    let { isOpen, onClose = () => { }, callListApi = () => { }, expenseType = 1, callBackServiceData = () => { }, getDataCallBack = () => { }, showExpenseTypeDisable = false } = props;

    const obj = {
        company_id: "",
        type: expenseType ? expenseType : 1, // 1 = Parts, 2 = Service
        part_category_id: {},
        name: "",
        category_number: "",
        type_unit: {},
        code: "",
        manufacture_id: {},
        account_category: '',
        account_sub_category: '',
        gst_rate: {},
        hsn_code: "",
        odometer_reading: 1, // 0 = Off, 1= On
        odometer_kms: '',
        time_interval: 1, // 0 = Off, 1= On
        time_interval_days: '',
        inventory: 0,     // 0 = off, 1= on
        stock_in_hand: '',
        rate: '',
        amount: '',
        open_kms: '',
        total_kms: '',
        account_to_reflect: {},
    }
    const { workShopChild } = useContext(UserContext);
    const workShopChildCategory = workShopChild?.find((i) => i?.label === "Category");
    const workShopChildManufacturer = workShopChild?.find((i) => i?.label === "Manufacturer");

    const [showAddPartsCategory, setShowPartsCategory] = useState(false);
    const [manufacturerModelData, setManufacturerModelData] = useState(false);

    const [formValue, setFormValue] = useState(obj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [expenseList, setExpenseList] = useState([]);
    const [dataMeasurementUnit, setDataMeasurementUnit] = useState([]);
    const [gstTypeList, setGstTypeList] = useState([]);

    const handleOnChange = async (name, value) => {
        if (name === 'time_interval_days') {
            const num = Number(value);
            if (num > 365) {
                value = 365;
            } else if (num < 0) {
                value = '';
            }
        }
        const stateObj = { ...formValue, [name]: value };
        if (name === 'stock_in_hand' || name === 'rate') {
            stateObj['amount'] = stateObj?.stock_in_hand * stateObj?.rate;
        }
        if (name === 'inventory') {
            stateObj['stock_in_hand'] = '';
            stateObj['rate'] = '';
            stateObj['amount'] = '';
            stateObj['open_kms'] = '';
            stateObj['total_kms'] = '';
            stateObj['account_to_reflect'] = {};
        }
        if (name === 'type') {
            stateObj['part_category_id'] = {};
            stateObj['name'] = '';
            stateObj['category_number'] = '';
            stateObj['code'] = '';
            stateObj['type_unit'] = {};
            stateObj['manufacture_id'] = {};
            stateObj['gst_rate'] = {};
            stateObj['hsn_code'] = '';
            stateObj['odometer_kms'] = '';
            stateObj['time_interval_days'] = '';
            stateObj['stock_in_hand'] = '';
            stateObj['rate'] = '';
            stateObj['amount'] = '';
            stateObj['open_kms'] = '';
            stateObj['total_kms'] = '';
            stateObj['account_to_reflect'] = {};
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, stateObj?.type === 1 ? errorSchema.addEditItems1 : errorSchema.addEditItems2);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        if (name === 'part_category_id') {
            stateObj['manufacture_id'] = {};
            stateObj['type_unit'] = { label: item?.unit?.name, value: item?.unit?.id };
            stateObj['gst_rate'] = gstTypeList?.find((el) => el?.value === item?.gst_rate);
            stateObj['hsn_code'] = item?.hsn_code;
            stateObj['odometer_reading'] = item?.odometer_reading;
            stateObj['time_interval'] = item?.time_interval;
            if (item?.odometer_reading) {
                stateObj['odometer_kms'] = item?.odometer_kms;
            }
            if (item?.time_interval) {
                stateObj['time_interval_days'] = item?.time_interval_days;
            }
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, formValue?.type === 1 ? errorSchema.addEditItems1 : errorSchema.addEditItems2);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async (shouldCloseModal = true) => {
        const toastId = "api-toast";
        try {
            if (isOpen?._id) {
                let object = {
                    ...formValue,
                    id: isOpen?._id,
                    name: formValue?.type === 1 ? formValue?.category_number : formValue?.name,
                    company_id: StorageService.getCompanyId(),
                    gst_rate: formValue?.gst_rate?.value,
                    account_category: formValue?.account_to_reflect?.account_category ? formValue?.account_to_reflect?.account_category : '',
                    account_sub_category: formValue?.account_to_reflect?.account_sub_category ? formValue?.account_to_reflect?.account_sub_category : '',
                    odometer_kms: formValue?.odometer_reading ? formValue?.odometer_kms : 0,
                    time_interval_days: formValue?.time_interval ? formValue?.time_interval_days : 0,
                    type_unit: formValue?.type_unit?.label,
                    manufacture_id: formValue?.manufacture_id?.value,
                    part_category_id: formValue?.part_category_id?.value,
                }
                delete object.account_to_reflect;
                delete object._id;
                const res = await editItems(object);
                if (res?.responseCode == 200) {
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage, { id: toastId });
                    }
                    setFormValue({});
                    setLoading(false);
                    onClose();
                    callListApi();
                } else {
                    setLoading(false);
                }
            } else {
                let object = {
                    ...formValue,
                    company_id: StorageService.getCompanyId(),
                    name: formValue?.type === 1 ? formValue?.category_number : formValue?.name,
                    gst_rate: formValue?.gst_rate?.value,
                    account_category: formValue?.account_to_reflect?.account_category ? formValue?.account_to_reflect?.account_category : '',
                    account_sub_category: formValue?.account_to_reflect?.account_sub_category ? formValue?.account_to_reflect?.account_sub_category : '',
                    odometer_kms: formValue?.odometer_reading ? formValue?.odometer_kms : 0,
                    time_interval_days: formValue?.time_interval ? formValue?.time_interval_days : 0,
                    type_unit: formValue?.type_unit?.label,
                    manufacture_id: formValue?.manufacture_id?.value,
                    part_category_id: formValue?.part_category_id?.value,
                }
                delete object.account_to_reflect;
                const res = await createItems(object);
                if (res?.responseCode == 200) {
                    callBackServiceData(res?.data);
                    getDataCallBack(res?.data);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage, { id: toastId });
                    }
                    setLoading(false);
                    setFormValue({});
                    onClose();
                    callListApi();
                } else {
                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, formValue?.type === 1 ? errorSchema.addEditItems1 : errorSchema.addEditItems2);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            await apiCallingFunction(true);
            setFormError("");

        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    };

    const propsAddParts = {
        ...props,
        onSubmit: handleOnSubmit,
        isLoadding: loading,
        disabled: loading,
    };

    const getExpenseHandler = async () => {
        try {
            const res = await getChartExpense({
                company_id: StorageService.getCompanyId(),
                category_id: 5,
                sub_category_id: 8,
            });

            if (res?.responseCode === 200) {
                const { category_id, sub_category_id } = res?.data;
                const details = res?.data?.categories?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?._id,
                        account_category: item?.type,
                        account_sub_category: item?.id,
                    };
                });

                // const updatedList = expenseArray.map((item) => ({
                //     ...item,
                //     category_id: category_id,
                //     sub_category_id: sub_category_id,
                // }));
                // if (!isEditDetails?.isEdit) {
                //     setExpenseArray(updatedList);
                // }
                setExpenseList(details);
            } else {
            }
        } catch (error) {
        }
    };

    const getGstTypeList = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getGstTypeData();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        label: `${el?.perc} %`,
                        value: el?.id
                    }
                })
                setGstTypeList(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        if (isOpen?._id && expenseList?.length > 0 && gstTypeList?.length > 0 && dataMeasurementUnit?.length > 0) {
            let findObj = expenseList?.find((el) => el?.account_category === isOpen?.account_category && el?.account_sub_category === isOpen?.account_sub_category)
            let gstTypes = gstTypeList?.find((el) => el?.value === isOpen?.gst_rate);
            setFormValue((s) => ({
                ...s,
                type: isOpen?.type, // 1 = Parts, 2 = Service
                category_number: isOpen?.category_number,
                part_category_id: { label: isOpen?.part_category_id?.name, value: isOpen?.part_category_id?.id },
                code: isOpen?.code,
                manufacture_id: { label: isOpen?.manufacture_id?.name, value: isOpen?.manufacture_id?.id },
                stock_in_hand: isOpen?.stock_in_hand,
                rate: isOpen?.rate,
                amount: isOpen?.amount,
                open_kms: isOpen?.open_kms,
                total_kms: isOpen?.total_kms,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
                account_to_reflect: findObj,
                gst_rate: gstTypes,
                hsn_code: isOpen?.hsn_code,
                type_unit: dataMeasurementUnit?.find((el) => el?.label === isOpen?.type_unit),
                part_type: isOpen?.part_type,
                inventory: isOpen?.inventory,
                odometer_reading: isOpen?.odometer_reading,
                odometer_kms: isOpen?.odometer_kms > 0 ? isOpen?.odometer_kms : '',
                time_interval: isOpen?.time_interval,
                time_interval_days: isOpen?.time_interval_days > 0 ? isOpen?.time_interval_days : '',
            }))
        }
    }, [isOpen, expenseList, gstTypeList, dataMeasurementUnit])

    const getMeasurementUnit = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getMeasurementUnitList();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })
                setDataMeasurementUnit(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getExpenseHandler();
        getGstTypeList();
        getMeasurementUnit();
    }, [])

    const fetchPartCategory = useCallback(async (search, page, limit) => {
        try {
            const response = await getPartCategoryList({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
                status: 1
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.partData.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    const fetchManufacturer = useCallback(async (search, page, limit) => {
        try {
            const response = await getManufacturerList({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
                status: 1
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.manufactureData.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    // Add New Category Modal Start //
    const addNewCategoryHandler = () => {
        setShowPartsCategory(true)
    }

    let addPartsCategoryModalProps = {
        isOpen: showAddPartsCategory,
        closeModal: (e) => setShowPartsCategory(false),
        modalMainClass: " _dashCommon_Modal _addExpModal",
        modalTitle: showAddPartsCategory?.isDetails ? 'View Category' : (showAddPartsCategory?._id ? "Update Category" : "Add Category"),
        hideFooterSumbmitBtn: showAddPartsCategory?.isDetails ? true : false,
        hideCompletelyFoolter: showAddPartsCategory?.isDetails ? true : false,
        footerPart: true,
        submitTitle: "Save",
        getDataCallBack: (data) => onhandleSelect({ ...data, label: data?.name, value: data?._id }, 'part_category_id') // setFormValue((s) => ({ ...s, part_category_id: { label: data?.name, value: data?._id } })),
    };
    // Add New Category Modal End //


    // Add New Manufacturer Modal Start //

    const addNewManufacturerHandler = () => {
        setManufacturerModelData(true)
    }

    let manufacturerModelProps = {
        isOpen: manufacturerModelData,
        closeModal: (e) => setManufacturerModelData(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
        submitTitle: manufacturerModelData?.isDetails ? "View Manufacturer" : (manufacturerModelData?._id ? 'Update Manufacturer' : 'Add Manufacturer'),
        footerPart: manufacturerModelData?.isDetails ? true : false,
        hideFooterSumbmitBtn: manufacturerModelData?.isDetails ? true : false,
        hideCompletelyFoolter: manufacturerModelData?.isDetails ? true : false,
        getDataCallBack: (data) => onhandleSelect({ ...data, label: data?.name, value: data?._id }, 'manufacture_id')// setFormValue((s) => ({ ...s, manufacture_id: { label: data?.name, value: data?._id } })),
    }

    // Add New Manufacturer Modal End //

    const partCategoryClearHandler = () => {
        setFormValue((s) => ({
            ...s,
            part_category_id: {},
            manufacture_id: {},
            odometer_reading: 1,
            time_interval: 1,
            odometer_kms: '',
            time_interval_days: '',
            gst_rate: {},
            hsn_code: '',
            type_unit: {}
        }))
    }

    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">{isOpen?.isDetails ? 'View Item' : (isOpen?._id ? 'Update Item' : 'Add Item')}</h5>
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }}
                    onClick={() => {
                        onClose(!isOpen);
                    }}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black"
                        />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className='__whAdd_item'>
                    {!isOpen?._id ? <div className='checkBx_lv mt-0 p-0 gap-4' style={{ width: '100%' }}>
                        {
                            constant.itemParts?.map((el, ind) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <div className='_dualCheckr_bx'>
                                            <input
                                                style={{ marginTop: '2px' }}
                                                className="form-check-input"
                                                id={+ind + `type${ind}` + el?.value}
                                                type="radio"
                                                name="type"
                                                disabled={showExpenseTypeDisable ? true : (isOpen?.isDetails ? true : false)}
                                                checked={Number(formValue?.type) === Number(el?.value)}
                                                value={formValue?.type ? formValue?.type : ""}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, el?.value)
                                                }
                                            />
                                            <label style={{ fontSize: '14px' }} htmlFor={+ind + `type${ind}` + el.value} className="form-check-label" >
                                                {el.label}
                                            </label>
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </div> : <></>}

                    {
                        formValue?.type === 1 &&
                        <>
                            <div className='singleDiv'>
                                <CityDropdownForTrip
                                    label="Category"
                                    placeholder="Category"
                                    fetchData={fetchPartCategory}
                                    pageSize={20}
                                    disabled={isOpen?.isDetails ? true : false}
                                    selectedItem={formValue.part_category_id ? formValue?.part_category_id : null}
                                    onChange={(data) => onhandleSelect(data, 'part_category_id')}
                                    error={formError['part_category_id.label']}
                                    errorMessage={formError['part_category_id.label']}
                                    isAddButton={workShopChildCategory?.create === 1 ? true : false}
                                    addButtonAction={(e) => addNewCategoryHandler(e)}
                                    isClearOption={formValue?.part_category_id?.label ? true : false}
                                    isClearHandleChange={(e) => partCategoryClearHandler(e)}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label={formValue?.part_category_id?.name ? `${formValue?.part_category_id?.name} Name * ` : 'Category Name * '}
                                    placeholder={formValue?.part_category_id?.name ? `${formValue?.part_category_id?.name} Name * ` : 'Category Name * '}
                                    name='category_number'
                                    value={formValue.category_number}
                                    disabled={isOpen?.isDetails ? true : false}
                                    focus={!!(typeof formError === "object" && formError?.category_number)}
                                    error={!!(typeof formError === "object") ? formError?.category_number : ""}
                                    maxLength="50"
                                    // onKeyDown={handleKeyDown}
                                    onInput={utils.maxLengthCheck}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                                // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CityDropdownForTrip
                                    label="Manufacturer"
                                    placeholder="Manufacturer"
                                    fetchData={fetchManufacturer}
                                    pageSize={20}
                                    disabled={isOpen?.isDetails ? true : false}
                                    selectedItem={formValue.manufacture_id ? formValue?.manufacture_id : null}
                                    onChange={(data) => onhandleSelect(data, 'manufacture_id')}
                                    error={formError['manufacture_id.label']}
                                    errorMessage={formError['manufacture_id.label']}
                                    isAddButton={workShopChildManufacturer?.create === 1 ? true : false}
                                    addButtonAction={(e) => addNewManufacturerHandler(e)}
                                    isClearOption={formValue?.manufacture_id?.label ? true : false}
                                    isClearHandleChange={(e) => setFormValue((s) => ({ ...s, manufacture_id: {} }))}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label='Manufacturer Code'
                                    placeholder='Manufacturer Code'
                                    name='code'
                                    value={formValue.code}
                                    disabled={isOpen?.isDetails ? true : false}
                                    focus={!!(typeof formError === "object" && formError?.code)}
                                    error={!!(typeof formError === "object") ? formError?.code : ""}
                                    maxLength="8"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                />
                            </div>

                            <div className='singleDiv'>
                                {/* <CityDropdownForTrip
                            label="Measurement Unit"
                            placeholder="Measurement Unit"
                            fetchData={fetchUnit}
                            pageSize={20}
                            selectedItem={formValue.type_unit ? formValue?.type_unit : null}
                            onChange={(data) => setFormValue((s) => ({ ...s, type_unit: data }))}
                            error={formError['type_unit.label']}
                            errorMessage={formError['type_unit.label']}
                        /> */}
                                <CustomSelect
                                    options={dataMeasurementUnit} // {constant.TaxPerct}
                                    name="type_unit"
                                    flotingLabel="Measurement Unit"
                                    placeholder="Measurement Unit"
                                    value={formValue?.type_unit}
                                    disabled={isOpen?.isDetails ? true : false}
                                    error={formError["type_unit.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'type_unit')}
                                    isClearOption={!isOpen?.isDetails ? true : false}
                                    isClearHandleChange={() => setFormValue((s) => ({ ...s, type_unit: { label: '', value: '' } }))}
                                />
                            </div>

                            <div className='halfDiv'>
                                <CustomSelect
                                    options={gstTypeList} // {constant.TaxPerct}
                                    name="gst_rate"
                                    flotingLabel="GST Rate"
                                    placeholder="GST Rate"
                                    value={formValue?.gst_rate}
                                    disabled={isOpen?.isDetails ? true : false}
                                    error={formError["gst_rate.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'gst_rate')}
                                    isClearOption={!isOpen?.isDetails ? true : false}
                                    isClearHandleChange={() => setFormValue((s) => ({ ...s, gst_rate: { label: '', value: '' } }))}
                                />
                            </div>

                            <div className='halfDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="HSN Code"
                                    label="HSN Code"
                                    disabled={isOpen?.isDetails ? true : false}
                                    name='hsn_code'
                                    value={formValue.hsn_code}
                                    focus={!!(typeof formError === "object" && formError?.hsn_code)}
                                    error={!!(typeof formError === "object") ? formError?.hsn_code : ""}
                                    onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                    maxLength="6"
                                    onInput={utils.maxLengthCheck}
                                />
                            </div>
                        </>
                    }

                    {
                        formValue?.type === 2 &&
                        <>
                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label='Service Name * '
                                    placeholder='Service Name * '
                                    name='name'
                                    value={formValue.name}
                                    disabled={isOpen?.isDetails ? true : false}
                                    focus={!!(typeof formError === "object" && formError?.name)}
                                    error={!!(typeof formError === "object") ? formError?.name : ""}
                                    maxLength="30"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                                />
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label='Service Code'
                                    placeholder='Service Code'
                                    name='code'
                                    value={formValue.code}
                                    disabled={isOpen?.isDetails ? true : false}
                                    focus={!!(typeof formError === "object" && formError?.code)}
                                    error={!!(typeof formError === "object") ? formError?.code : ""}
                                    maxLength="8"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                />
                                {!isOpen?.isDetails ? <p className='_bottomPLine'>Leave Blank to Auto generate</p> : <></>}
                            </div>

                            <div className='singleDiv'>
                                <CustomSelect
                                    options={expenseList}
                                    name="account_to_reflect"
                                    flotingLabel="Account Reflection"
                                    placeholder="Account Reflection"
                                    value={formValue?.account_to_reflect}
                                    disabled={isOpen?.isDetails ? true : false}
                                    error={formError["account_to_reflect.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'account_to_reflect')}
                                />
                            </div>

                            <div className='halfDiv'>
                                <CustomSelect
                                    options={gstTypeList} // {constant.TaxPerct}
                                    name="gst_rate"
                                    flotingLabel="GST Rate"
                                    placeholder="GST Rate"
                                    value={formValue?.gst_rate}
                                    disabled={isOpen?.isDetails ? true : false}
                                    error={formError["gst_rate.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'gst_rate')}
                                />
                            </div>

                            <div className='halfDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="HSN Code"
                                    label="HSN Code"
                                    disabled={isOpen?.isDetails ? true : false}
                                    name='hsn_code'
                                    value={formValue.hsn_code}
                                    focus={!!(typeof formError === "object" && formError?.hsn_code)}
                                    error={!!(typeof formError === "object") ? formError?.hsn_code : ""}
                                    onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                    maxLength="6"
                                    onInput={utils.maxLengthCheck}
                                />
                            </div>
                        </>
                    }

                    {formValue?.type === 1 &&
                        <>
                            <div className='singleDiv mt-1 __sigCheckBx'>
                                <h6>Opening stock of Inventory</h6>

                                <div className="_anvSwitcherNew form-check form-switch" >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="inventory"
                                        disabled={isOpen?.isDetails ? true : false}
                                        checked={formValue?.inventory}
                                        onChange={(e) => handleOnChange('inventory', e.target.checked ? 1 : 0)}
                                    />
                                </div>
                            </div>

                            {formValue?.inventory ?
                                <React.Fragment>
                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Stock In Hand"
                                            label="Stock In Hand"
                                            name='stock_in_hand'
                                            disabled={isOpen?.isDetails ? true : false}
                                            value={formValue.stock_in_hand}
                                            focus={!!(typeof formError === "object" && formError?.stock_in_hand)}
                                            error={!!(typeof formError === "object") ? formError?.stock_in_hand : ""}
                                            onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                            maxLength="10"
                                            onInput={utils.maxLengthCheck}
                                        />
                                    </div>
                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Rate"
                                            label="Rate"
                                            name='rate'
                                            disabled={isOpen?.isDetails ? true : false}
                                            value={formValue.rate}
                                            focus={!!(typeof formError === "object" && formError?.rate)}
                                            error={!!(typeof formError === "object") ? formError?.rate : ""}
                                            // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                            maxLength="6"
                                            onKeyDown={handleKeyDown}
                                            onInput={utils.maxLengthCheck}
                                            onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                                        // onChange={({ target: { name, value } }) =>
                                        //     handleOnChange(name, value)
                                        // }
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Amount"
                                            label="Amount"
                                            name='amount'
                                            disabled={isOpen?.isDetails ? true : false}
                                            value={formValue.amount > 0 ? formValue.amount : ''}
                                            focus={!!(typeof formError === "object" && formError?.amount)}
                                            error={!!(typeof formError === "object") ? formError?.amount : ""}
                                            // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                            maxLength="10"
                                            onKeyDown={handleKeyDown}
                                            onInput={utils.maxLengthCheck}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={expenseList}
                                            name="account_to_reflect"
                                            flotingLabel="Account Reflection"
                                            placeholder="Account Reflection"
                                            value={formValue?.account_to_reflect}
                                            disabled={isOpen?.isDetails ? true : false}
                                            error={formError["account_to_reflect.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'account_to_reflect')}
                                        />
                                    </div>

                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Opening KMs"
                                            label="Opening KMs"
                                            name='open_kms'
                                            disabled={isOpen?.isDetails ? true : false}
                                            value={formValue.open_kms > 0 ? formValue.open_kms : ''}
                                            focus={!!(typeof formError === "object" && formError?.open_kms)}
                                            error={!!(typeof formError === "object") ? formError?.open_kms : ""}
                                            // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                            maxLength="6"
                                            onKeyDown={handleKeyDown}
                                            onInput={utils.maxLengthCheck}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>
                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Total Km"
                                            label="Total Km"
                                            name='total_kms'
                                            maxLength="6"
                                            onInput={utils.maxLengthCheck}
                                            onKeyDown={handleKeyDown}
                                            disabled={isOpen?.isDetails ? true : false}
                                            value={formValue.total_kms > 0 ? formValue.total_kms : ''}
                                            focus={!!(typeof formError === "object" && formError?.total_kms)}
                                            error={!!(typeof formError === "object") ? formError?.total_kms : ""}
                                            // onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>
                                </React.Fragment>
                                : <></>}
                        </>
                    }

                    <div className='singleDiv mt-1 __sigCheckBx' style={{ marginBottom: '-6px' }}>
                        <h6>Service Reminders</h6>
                    </div>

                    <div className='singleDiv  __halfCheckBx'>
                        <span>Odometer Reading</span>
                        <div className="_anvSwitcherNew form-check form-switch" >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="odometer_reading"
                                disabled={isOpen?.isDetails ? true : false}
                                checked={formValue?.odometer_reading}
                                onChange={(e) => handleOnChange('odometer_reading', e.target.checked ? 1 : 0)}
                            />
                        </div>
                    </div>
                    {
                        formValue?.odometer_reading ?
                            <div className='singleDiv __disBladeFlex'>
                                <CommonInput
                                    type="text"
                                    placeholder="Select Default Number of KM’s"
                                    name='odometer_kms'
                                    label="Select Default Number of KM’s"
                                    maxLength="6"
                                    disabled={isOpen?.isDetails ? true : false}
                                    onInput={utils.maxLengthCheck}
                                    value={formValue.odometer_kms}
                                    focus={!!(typeof formError === "object" && formError?.odometer_kms)}
                                    error={!!(typeof formError === "object") ? formError?.odometer_kms : ""}
                                    onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                                />
                                <span className={formError?.odometer_kms ? '__flFloat __errorFlt' : '__flFloat'}>KMs</span>
                            </div>
                            : <></>
                    }

                    <div className='singleDiv  __halfCheckBx'>
                        <span>On Time Interval</span>
                        <div className="_anvSwitcherNew form-check form-switch" >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="time_interval"
                                disabled={isOpen?.isDetails ? true : false}
                                checked={formValue?.time_interval}
                                onChange={(e) => handleOnChange('time_interval', e.target.checked ? 1 : 0)}
                            />
                        </div>
                    </div>

                    {formValue?.time_interval ?
                        <div className='singleDiv __disBladeFlex'>
                            <CommonInput
                                type="text"
                                placeholder="Select Default Number of Days"
                                name='time_interval_days'
                                label="Select Default Number of Days"
                                maxLength="3"
                                disabled={isOpen?.isDetails ? true : false}
                                onInput={utils.maxLengthCheck}
                                value={formValue.time_interval_days}
                                focus={!!(typeof formError === "object" && formError?.time_interval_days)}
                                error={!!(typeof formError === "object") ? formError?.time_interval_days : ""}
                                onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                            />
                            <span className={formError?.time_interval_days ? '__flFloat __errorFlt' : '__flFloat'}>Days</span>
                        </div>
                        :
                        <></>
                    }
                </div>
            </div>

            {!isOpen?.isDetails ? <div className="offcanvas-footer">
                <button className="_addComm_btn _sameWid" onClick={(e) => handleOnSubmit(e)} disabled={loading}>
                    {loading ? 'Loading...' : 'Save'}
                </button>
            </div> : <></>}

            {/* Add New Category */}
            {showAddPartsCategory && <AddPartsCategory {...addPartsCategoryModalProps} />}

            {/* Add New Manufacturer */}
            {manufacturerModelData && <AddEditManufacturerModel {...manufacturerModelProps} />}
        </>
    )
}

export default WorkshopAddItem